/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import Cookie from 'js-cookie';
import {raf} from "../helpers/functions";

$(function(){
    function initCookiesInfo() {
        if(!Cookie.get('cookies-info-accepted')){
            let $cookies = $('.cookies-info');
            let $body = $('body');
            raf(function (){
                $cookies.addClass('not-accepted');
                $body.addClass('cookies-not-accepted');
            });

            $cookies.find('.btn').click(function(){
                raf(function () {
                    $cookies.removeClass('not-accepted');
                    $body.removeClass('cookies-not-accepted');
                });
                Cookie.set('cookies-info-accepted', 1, {expires: 180});
            });
        }
    }

    setTimeout(initCookiesInfo, 2000);
});
